import { ref, watch, computed } from '@vue/composition-api'
import http from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useReportsList() {
  // Use toast
  const toast = useToast()

  const refReportsListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'packet', label: 'Пакеты', sortable: true },
    { key: 'count', label: 'Кол-во подключения', sortable: false },
  ]
  const perPage = ref(10)
  const totalReports = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('packet')
  const isSortDirDesc = ref(true)
  const dateFilter = ref(null)
  const dealerFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refReportsListTable.value ? refReportsListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: (perPage ? perPage.value : 0) * ((currentPage ? currentPage.value : 0) - 1) + localItemsCount,
      of: totalReports.value,
    }
  })

  const refetchData = () => {
    console.log(refReportsListTable)
    if (refReportsListTable.value) {
      refReportsListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, dateFilter, dealerFilter], () => {
    refetchData()
  })

  const fetchReports = (ctx, callback) => {
    const date = dateFilter.value ? dateFilter.value.split('—') : []
    const startDate = date.length > 0 ? date[0] : ''
    const endDate = date.length > 1 ? date[1] : startDate
    http.get('/dealer/connected-packets', {
      params: {
        keyword: searchQuery.value,
        limit: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        dealer: dealerFilter.value ? dealerFilter.value : '',
        startDate,
        endDate,
      },
    })
      .then(response => {
        const { data, total } = response.data
        callback(data)
        totalReports.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    fetchReports,
    tableColumns,
    perPage,
    currentPage,
    totalReports,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refReportsListTable,
    refetchData,
    dateFilter,
    dealerFilter,
  }
}
